import { useHistory } from 'react-router-dom';

const useAttendance = () => {
  const history = useHistory();

  const sendToAttendance = (dateInfo, courseId, courseThumbnail) => {
    history.push({
      pathname: '/cursos/asistencia',
      state: {
        update: true,
        isComingFrom: '/cursos/detalles',
        dateInfo,
        courseId,
        courseThumbnail,
      },
    });
  };
  return { sendToAttendance };
};

export default useAttendance;
